$(document).ready(function () {
    let awardTitle = document.getElementById("awardTitle");
    let listAwardTitles = document.getElementsByClassName("listAwardTitles");
    let temp;
    let count = 0;
    for (let index = 0; index < listAwardTitles.length; ++index) {
        if (listAwardTitles[index].dataset.id === awardTitle.dataset.id) {
            if (count === 1) {
                listAwardTitles[temp].classList.remove("active");
                break;
            }
            temp = index;
            count++;
            listAwardTitles[index].classList.add("active");
        }
    }
});